import Contact from "views/Contact/Contact.jsx";
import AboutUs from "views/AboutUs/AboutUs.jsx";
import LandingPage from "views/LandingPage/LandingPage.jsx";

var indexRoutes = [
  { path: "/kontakt", name: "Contact", component: Contact },
  { path: "/om-oss", name: "AboutUs", component: AboutUs },
  { path: "/", name: "LandingPage", component: LandingPage },
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx